// @flow
import type {ShippingMethodType} from 'constants/flow/flowTypesCheckout';

type ActionType = {type: string, shippingActive: ShippingMethodType};

export const initialState = {
    price: '',
    code: '',
    title: '',
    description: '',
    discount: '',
    selected: false,
};

/**
 * Set active shipping method
 *
 * @param {object|null} state Current state
 * @param {actionType} action Received action
 * @returns {ShippingMethodType} Active shipping object
 */
export default function shippingMethodActive(
    state: ShippingMethodType = initialState,
    action: ActionType,
): ShippingMethodType {
    switch (action.type) {
        case 'SET_ACTIVE_SHIPPING':
            return action.shippingActive;
        default:
            return state;
    }
}
